import React, { useState, useEffect, useRef } from 'react';
import { doc, updateDoc, collection, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../servicios/firebase';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FaSave, FaUserPlus, FaFilePdf, FaImage, FaTimes } from 'react-icons/fa';

const ModalManifiesto = ({ viaje, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [mensajeEstado, setMensajeEstado] = useState("");
  
  const [choferes, setChoferes] = useState([]);
  const [choferSeleccionado, setChoferSeleccionado] = useState(""); 
  const [nuevoChofer, setNuevoChofer] = useState({ nombre: '', telefono: '' });
  const [mostrarFormChofer, setMostrarFormChofer] = useState(false);

  const manifiestoRef = useRef(null); 

  useEffect(() => {
    const cargarChoferes = async () => {
      try {
        const q = query(collection(db, 'choferes'), orderBy('nombre'));
        const snap = await getDocs(q);
        const lista = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setChoferes(lista);
        if (viaje.choferId) setChoferSeleccionado(viaje.choferId);
      } catch(e) { console.error(e); }
    };
    cargarChoferes();
  }, [viaje]);

  const guardarChofer = async () => {
    if (!nuevoChofer.nombre || !nuevoChofer.telefono) return alert("Faltan datos");
    try {
      const docRef = await addDoc(collection(db, 'choferes'), nuevoChofer);
      const nuevo = { id: docRef.id, ...nuevoChofer };
      setChoferes([...choferes, nuevo]);
      asignarChoferAViaje(docRef.id);
      setNuevoChofer({ nombre: '', telefono: '' });
      setMostrarFormChofer(false);
    } catch (e) { alert("Error al guardar"); }
  };

  const asignarChoferAViaje = async (idChofer) => {
    setChoferSeleccionado(idChofer);
    if (viaje.tipo === 'REAL') {
        await updateDoc(doc(db, 'viajes', viaje.id), { choferId: idChofer });
    }
  };

  const pasajeros = (viaje.ocupados || []).map(p => {
    const asiento = typeof p === 'object' ? p.asiento : p;
    const nombre = typeof p === 'object' ? p.nombre : 'Sin Datos';
    const tel = typeof p === 'object' ? p.telefono : '';
    const numAsiento = parseInt(asiento.replace('a', '')) || 99; 
    return { asiento, nombre, tel, numAsiento };
  }).sort((a, b) => a.numAsiento - b.numAsiento);

  const choferObj = choferes.find(c => c.id === choferSeleccionado);

  const descargarArchivo = async (tipo) => {
    if (!manifiestoRef.current) return;
    setLoading(true);
    setMensajeEstado(tipo === 'PDF' ? "📄 Creando PDF..." : "📸 Creando Imagen...");

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const canvas = await html2canvas(manifiestoRef.current, { 
            scale: 2, 
            useCORS: true,
            logging: false,
            y: 0,
        });

        const imgData = canvas.toDataURL('image/png');

        if (tipo === 'PDF') {
            const imgWidth = 210; 
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const pdf = new jsPDF('p', 'mm', [imgWidth, imgHeight]);
            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`Lista_${viaje.hora.replace(':','')}.pdf`);
        } else {
            const link = document.createElement('a');
            link.href = imgData;
            link.download = `Lista_${viaje.hora.replace(':','')}.png`;
            link.click();
        }
    } catch (error) {
        alert("Error al generar el archivo");
    } finally {
        setLoading(false);
        setMensajeEstado("");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="bg-slate-100 w-full max-w-md rounded-3xl shadow-2xl flex flex-col max-h-[90vh] overflow-hidden relative">
        
        <div className="bg-slate-900 p-4 flex justify-between items-center text-white shrink-0 z-20 shadow-md">
            <h2 className="font-bold text-lg">📄 Lista de Abordaje</h2>
            <button onClick={onClose} className="bg-slate-800 w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-500 transition">
                <FaTimes />
            </button>
        </div>

        {loading && (
            <div className="absolute inset-0 bg-white/95 z-50 flex flex-col items-center justify-center text-center p-6 text-slate-800">
                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4"></div>
                <p className="font-bold">{mensajeEstado}</p>
            </div>
        )}

        <div className="flex-1 overflow-y-auto p-4 pb-48"> 
            
            <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm mb-6">
                <div className="flex justify-between items-center mb-2">
                    <label className="text-[10px] font-bold text-slate-400 uppercase">Asignar Chofer (Opcional)</label>
                    <button onClick={() => setMostrarFormChofer(!mostrarFormChofer)} className="text-blue-600 text-[10px] font-bold border border-blue-100 px-2 py-1 rounded">
                        <FaUserPlus/> Nuevo
                    </button>
                </div>

                {mostrarFormChofer ? (
                    <div className="bg-blue-50 p-3 rounded-lg">
                        <input autoFocus placeholder="Nombre" className="w-full p-2 mb-2 text-sm border rounded bg-white" value={nuevoChofer.nombre} onChange={e => setNuevoChofer({...nuevoChofer, nombre: e.target.value})}/>
                        <input type="tel" placeholder="Teléfono" className="w-full p-2 mb-2 text-sm border rounded bg-white" value={nuevoChofer.telefono} onChange={e => setNuevoChofer({...nuevoChofer, telefono: e.target.value})}/>
                        <button onClick={guardarChofer} className="w-full bg-blue-600 text-white py-2 rounded text-sm font-bold flex gap-2 justify-center items-center"><FaSave/> Guardar</button>
                    </div>
                ) : (
                    <select 
                        className="w-full p-3 bg-slate-50 border rounded-lg font-bold text-slate-800 text-sm outline-none"
                        value={choferSeleccionado}
                        onChange={(e) => asignarChoferAViaje(e.target.value)}
                    >
                        <option value="">-- Seleccionar Chofer --</option>
                        {choferes.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                    </select>
                )}
            </div>

            <div className="flex justify-center">
                <div ref={manifiestoRef} style={{ width: '340px', backgroundColor: '#ffffff', paddingBottom: '20px' }}>
                    <div style={{ backgroundColor: '#000000', color: '#ffffff', padding: '20px', textAlign: 'center' }}>
                        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '2px' }}>Ángeles del Puerto</h1>
                        <p style={{ margin: '5px 0 0 0', fontSize: '10px', fontWeight: 'bold', color: '#9ca3af', textTransform: 'uppercase' }}>Lista de Abordaje</p>
                    </div>
                    
                    <div style={{ padding: '20px', borderBottom: '2px dashed #d1d5db', backgroundColor: '#f9fafb' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <div>
                                <p style={{ margin: 0, fontSize: '10px', color: '#9ca3af', fontWeight: 'bold' }}>HORA</p>
                                <p style={{ margin: 0, fontSize: '28px', fontWeight: '900' }}>{viaje.hora}</p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <p style={{ margin: 0, fontSize: '10px', color: '#9ca3af', fontWeight: 'bold' }}>FECHA</p>
                                <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>{viaje.fecha}</p>
                            </div>
                        </div>
                        <div style={{ padding: '10px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                           <p style={{ margin: 0, fontSize: '9px', color: '#9ca3af', fontWeight: 'bold' }}>ORIGEN / DESTINO</p>
                           <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold' }}>{viaje.origen} ➝ {viaje.destino}</p>
                        </div>
                        <p style={{ margin: '15px 0 0 0', textAlign: 'center', fontSize: '12px', fontWeight: 'bold', color: '#1d4ed8' }}>
                            CHOFER: {choferObj?.nombre || '---'}
                        </p>
                    </div>

                    <div style={{ padding: '15px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                    <th style={{ textAlign: 'left', padding: '10px 5px', fontSize: '10px', color: '#9ca3af' }}>#</th>
                                    <th style={{ textAlign: 'left', padding: '10px 5px', fontSize: '10px', color: '#9ca3af' }}>PASAJERO</th>
                                    <th style={{ textAlign: 'right', padding: '10px 5px', fontSize: '10px', color: '#9ca3af' }}>[ ]</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pasajeros.map((p, i) => (
                                    <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                        <td style={{ padding: '12px 5px' }}>
                                            <div style={{ width: '28px', height: '28px', backgroundColor: '#111827', color: '#ffffff', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '13px' }}>
                                                {p.asiento.replace('a','')}
                                            </div>
                                        </td>
                                        <td style={{ padding: '12px 5px' }}>
                                            <p style={{ margin: 0, fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>{p.nombre}</p>
                                            <p style={{ margin: 0, fontSize: '9px', color: '#6b7280' }}>{p.tel || ''}</p>
                                        </td>
                                        <td style={{ padding: '12px 5px', textAlign: 'right' }}>
                                            <div style={{ width: '16px', height: '16px', border: '2px solid #d1d5db', borderRadius: '3px', display: 'inline-block' }}></div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div className="absolute bottom-0 w-full p-4 bg-white border-t border-slate-200 z-30 flex flex-col gap-2">
            <button 
                onClick={() => descargarArchivo('PDF')}
                disabled={loading}
                className="w-full py-4 rounded-xl font-black text-white bg-red-600 hover:bg-red-700 shadow-lg flex items-center justify-center gap-2 disabled:bg-slate-300"
            >
                <FaFilePdf size={20}/> GENERAR PDF PARA WHATSAPP
            </button>
            <button 
                onClick={() => descargarArchivo('IMG')}
                disabled={loading}
                className="w-full py-3 rounded-xl font-bold text-slate-600 bg-slate-100 border border-slate-200 text-sm flex items-center justify-center gap-2"
            >
                <FaImage size={18}/> Descargar como Imagen
            </button>
        </div>

      </div>
    </div>
  );
};

export default ModalManifiesto;